/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import { colors } from '@getgo/chameleon-core';
import { Text } from '@getgo/chameleon-chakra-ui';
import React, { useContext } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Opacity, Spacing } from '../../../../../themes/GoToTheme';
import { GoToHeadingText } from '../Texts/GoToHeadingText';
import { SessionContext } from '../../../../../context/SessionContext';

interface HeadingProps {
  greeting?: boolean;
  heading?: string;
}

const messages = defineMessages({
  greeting: {
    id: 'goto.join.heading.greeting',
  },
  caption: {
    id: 'goto.join.heading.caption',
  },
});

export const GoToJoinHeading: React.FC<HeadingProps> = ({
  heading,
  greeting,
}) => {
  const { formatMessage: f } = useIntl();
  return (
    <>
      <Greeting shouldGreet={!!greeting}></Greeting>
      <GoToHeadingText marginBottom={Spacing.CoreLayout3}>
        {makeLastSpaceUnbreakable(heading || f(messages.caption))}
      </GoToHeadingText>
    </>
  );
};

interface GreetingProps {
  shouldGreet: boolean;
}

const Greeting: React.FC<GreetingProps> = ({ shouldGreet }) => {
  const { formatMessage: f } = useIntl();
  const { firstName } = useContext(SessionContext);
  if (!firstName) {
    return null;
  }
  const greetingString = shouldGreet
    ? f(messages.greeting) + ' ' + firstName + '.'
    : '‏'; /* <-- Caution: invisible character. This is needed, so the page will not shift up, when there is no first name*/
  return (
    <Text
      tag='p'
      fontWeight={600}
      fontSize='1.75rem'
      lineHeight='2.1rem'
      color={colors.neutrals.n600}
      opacity={Opacity.Medium}
    >
      {greetingString}
    </Text>
  );
};

const makeLastSpaceUnbreakable = (string: String) =>
  string.replace(
    new RegExp(' ([^ ]*)$'),
    ' $1' // <-- Caution: unbreakable character before $1.
  );

